import { render, staticRenderFns } from "./HistoricDetails.vue?vue&type=template&id=244e76d5&lang=pug"
import script from "./HistoricDetails.vue?vue&type=script&lang=js"
export * from "./HistoricDetails.vue?vue&type=script&lang=js"
import style0 from "./HistoricDetails.vue?vue&type=style&index=0&id=244e76d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports